import { render, staticRenderFns } from "./ScreeningStep.vue?vue&type=template&id=2ff3a2f7&scoped=true&"
import script from "./ScreeningStep.vue?vue&type=script&lang=js&"
export * from "./ScreeningStep.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningStep.vue?vue&type=style&index=0&id=2ff3a2f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3a2f7",
  null
  
)

export default component.exports